import React from "react";
import "./Home.css";
import donation from "./Donation";
import ComingSoon from "./ComingSoon";
import { Link } from "react-router-dom";


export default function Home() {
    return (
        <>
            <section
                style={{
                    // backgroundImage: `
                    //   linear-gradient(
                    //     rgba(248, 246, 239, 0.4),
                    //     rgba(248, 246, 239, 0.8)
                    //   ),
                    //   url("https://images.unsplash.com/photo-1585036156171-384164a8c675?auto=format&fit=crop&w=1600&q=80")
                    // `,

                    backgroundImage: `
    
      url("${process.env.PUBLIC_URL}/Img/background2.jpg")
    `,

                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    // backgroundAttachment: "fixed",
                    width: "100%",
                    color: "white"
                }}
            >
                {/* ================= CAROUSEL SECTION ================= */}

                <section className="hero" >

                    <div className="leaf leaf1">🍃</div>
                    <div className="leaf leaf2">🍃</div>
                    <div className="leaf leaf3">🌿</div>
                    <div className="leaf leaf4">🌿</div>

                    {/* Left Floating Icons */}
                    <div className="floating-icons left-icons">
                        <div className="icon-box">
                            <i className="bi bi-moon-stars-fill"></i>
                        </div>

                        <div className="icon-box">
                            <i className="bi bi-book-fill"></i>
                        </div>

                        <div className="icon-box">
                            <i className="bi bi-stars"></i>
                        </div>
                    </div>

                    {/* Right Floating Icons */}
                    <div className="floating-icons right-icons">
                        <div className="icon-box">
                            <i className="bi bi-bank"></i>
                        </div>

                        <div className="icon-box">
                            <i className="bi bi-heart-fill"></i>
                        </div>

                        <div className="icon-box">
                            <i className="bi bi-globe2"></i>
                        </div>
                    </div>


                    <div className="container">

                        <div
                            id="carouselExampleFade"
                            className="carousel slide carousel-fade custom-carousel"
                            data-bs-ride="carousel"
                            data-bs-interval="3000"
                        >

                            <div className="carousel-indicators">
                                <button type="button" data-bs-target="#carouselExampleFade" data-bs-slide-to="0"
                                    className="active" aria-current="true" aria-label="Slide 1"></button>
                                <button type="button" data-bs-target="#carouselExampleFade" data-bs-slide-to="1"
                                    aria-label="Slide 2"></button>
                                <button type="button" data-bs-target="#carouselExampleFade" data-bs-slide-to="2"
                                    aria-label="Slide 3"></button>
                            </div>

                            <div className="carousel-inner">

                                {/* Slide 1 */}
                                <div className="carousel-item active">
                                    <img
                                        src={process.env.PUBLIC_URL + "/Img/Darul yatama/1.jpeg"}
                                        className="d-block w-100 slide-img"
                                        alt="Slide 1"
                                    />
                                    <div className="overlay"></div>
                                    <div className="carousel-caption d-md-block">
                                        <h2 className="fw-bold">Misbahi Mission</h2>
                                        <p>Islamic guidance for everyone</p>
                                    </div>
                                </div>

                                {/* Slide 2 */}
                                <div className="carousel-item">
                                    <img
                                        src={process.env.PUBLIC_URL + "/Img/Darul yatama/2.jpeg"}
                                        className="d-block w-100 slide-img"
                                        alt="Slide 2"
                                    />
                                    <div className="overlay"></div>
                                    <div className="carousel-caption d-md-block">
                                        <h2 className="fw-bold">Islamic Learning</h2>
                                        <p>Knowledge that transforms lives</p>
                                    </div>
                                </div>

                                {/* Slide 3 */}
                                <div className="carousel-item">
                                    <img
                                        src={process.env.PUBLIC_URL + "/Img/Darul yatama/3.jpeg"}
                                        className="d-block w-100 slide-img"
                                        alt="Slide 3"
                                    />
                                    <div className="overlay"></div>
                                    <div className="carousel-caption d-md-block">
                                        <h2 className="fw-bold">Spiritual Development</h2>
                                        <p>Connecting hearts with the Divine</p>
                                    </div>
                                </div>
                            </div>

                            {/* Controls */}
                            <button className="carousel-control-prev" type="button"
                                data-bs-target="#carouselExampleFade" data-bs-slide="prev">
                                <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Previous</span>
                            </button>

                            <button className="carousel-control-next" type="button"
                                data-bs-target="#carouselExampleFade" data-bs-slide="next">
                                <span className="carousel-control-next-icon" aria-hidden="true"></span>
                                <span className="visually-hidden">Next</span>
                            </button>
                        </div>

                    </div>

                </section>

                {/* ================= HIGHLIGHTS ================= */}

                <section className="container my-5">

                    <h2 className="text-center fw-bold mb-5">
                        Our Highlights
                    </h2>

                    <div className="row g-4">

                        {/* Digital Library */}
                        <div className="col-lg-4 col-md-6">

                            <div className="card shadow feature-card h-100 text-center p-4">
                                <Link
                                    to="/library/pdf"
                                    style={{
                                        textDecoration: "none",
                                        color: "inherit"
                                    }}
                                >
                                    <i
                                        className="bi bi-file-earmark-pdf display-4"
                                        style={{ color: "#caa23d" }}
                                    ></i>

                                    <h4 className="mt-3">
                                        Books & PDFs
                                    </h4>

                                    <p>
                                        Explore a vast collection of Islamic books, Qur'an,
                                        Hadith, Tafsir, research papers and educational
                                        resources for every learner.
                                    </p>
                                </Link>
                            </div>

                        </div>

                        {/* Islamic Services */}
                        <div className="col-lg-4 col-md-6">

                            <div className="card shadow feature-card h-100 text-center p-4">
                                <Link
                                    to="/Comingsoon"
                                    style={{
                                        textDecoration: "none",
                                        color: "inherit"
                                    }}
                                >
                                    <i
                                        className="bi bi-moon-stars display-4"
                                        style={{ color: "#caa23d" }}
                                    ></i>

                                    <h4 className="mt-3">
                                        Islamic Services
                                    </h4>

                                    <p>
                                        Prayer times, mosques, Qibla and essential Islamic tools.
                                    </p>
                                </Link>
                            </div>

                        </div>

                        {/* Donation */}
                        <div className="col-lg-4 col-md-6">

                            <div className="card shadow feature-card h-100 text-center p-4">
                                <Link
                                    to="/donation"
                                    style={{
                                        textDecoration: "none",
                                        color: "inherit"
                                    }}
                                >
                                    <i
                                        className="bi bi-heart-fill display-4"
                                        style={{ color: "#caa23d" }}
                                    ></i>

                                    <h4 className="mt-3">
                                        Support Our Mission
                                    </h4>

                                    <p>
                                        Help us spread knowledge and serve humanity through
                                        education, charitable initiatives and community
                                        welfare projects.
                                    </p>
                                </Link>
                            </div>

                        </div>

                    </div>

                </section>

                {/* ================= SERVICES ================= */}

                <section className="container my-5">

                    <h2 className="text-center fw-bold mb-5">
                        Our Services
                    </h2>

                    <div className="row g-4">

                        {[
                            
                            {
                                icon: "bi bi-moon-stars",
                                title: "Islamic Services",
                                desc: "Prayer times, mosques, Qibla and essential Islamic tools.",
                                link: "/islamicservice/mosque"
                            },
                            {
                                icon: "bi bi-building",
                                title: "Departments",
                                desc: "Explore our educational and welfare departments.",
                                link: "/Comingsoon"
                            },
                            {
                                icon: "bi bi-patch-question",
                                title: "Darul Ifta",
                                desc: "Ask questions and receive authentic Islamic guidance.",
                                link: "/misbahidarul-ifta"
                            },
                            {
                                icon: "bi bi-heart-fill",
                                title: "Donation",
                                desc: "Support our educational and humanitarian initiatives.",
                                link: "/donation"
                            },
                            {
                                icon: "bi bi-envelope-paper",
                                title: "Contact Us",
                                desc: "Reach out for assistance, collaboration or inquiries.",
                                link: "/contactus"
                            }, {
                                icon: "bi bi-journal-bookmark",
                                title: "Qur'an & Tafsir",
                                desc: "Read the Holy Qur'an with authentic Tafsir and translations.",
                                link: "Comingsoon"
                            },
                            {
                                icon: "bi bi-file-earmark-pdf",
                                title: "Books & PDFs",
                                desc: "Access Islamic books, magazines and research publications.",
                                link: "/library/pdf"
                            },
                            {
                                icon: "bi bi-play-circle",
                                title: "Audio Lectures",
                                desc: "Listen to inspiring bayan, khutbahs and educational lectures.",
                                link: "/library/audio"
                            }

                        ].map((service, index) => (

                            <div className="col-lg-4 col-md-6" key={index}>

                                <Link
                                    to={service.link}
                                    style={{
                                        textDecoration: "none",
                                        color: "inherit"
                                    }}
                                >

                                    <div className="card feature-card h-100 text-center shadow p-4">

                                        <i
                                            className={`${service.icon} display-4`}
                                            style={{ color: "#caa23d" }}
                                        ></i>

                                        <h4 className="mt-3">
                                            {service.title}
                                        </h4>

                                        <p>
                                            {service.desc}
                                        </p>

                                    </div>

                                </Link>

                            </div>

                        ))}

                    </div>

                </section>

                {/* ================= BLOG ================= */}

                {/* <section className="container my-5">

                    <h2 className="text-center fw-bold mb-5">
                        Latest Articles
                    </h2>

                    <div className="row g-4">

                        {[1, 2, 3].map((item) => (

                            <div className="col-lg-4" key={item}>

                                <div className="card shadow h-100">

                                    <img
                                        src={`https://picsum.photos/600/350?random=${item}`}
                                        className="card-img-top"
                                        alt=""
                                    />

                                    <div className="card-body">

                                        <h5>
                                            Islamic Article {item}
                                        </h5>

                                        <p>
                                            Discover authentic Islamic
                                            knowledge, spirituality and
                                            educational insights.
                                        </p>

                                        <a
                                            href="/"
                                            className="btn btn-success"
                                        >
                                            Read More
                                        </a>

                                    </div>

                                </div>

                            </div>

                        ))}

                    </div>

                </section> */}

                {/* ================= DONATION CTA ================= */}

                <section className="cta-section">

                    <div className="container text-center">

                        <h2>
                            Support Misbahi Welfare Mission
                        </h2>

                        <p style={{ color: "white" }}>
                            Your contribution helps spread Islamic education,
                            support welfare initiatives, and serve the Ummah.
                        </p>

                        <Link
                            to="/donation"
                            className="btn-islamic"
                        >
                            Donate Now
                        </Link>

                    </div>

                </section>
            </section>
        </>
    );
}